"use client";

import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "motion/react";

import { DialogContent, DialogHeader, DialogTitle } from "../dialog.tsx";

import { SlotDetailsContent } from "./slot-details-content";

import { Separator } from "@/components/ui/separator";

const fadeAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export default function SlotDetailsModal() {
  const { t } = useTranslation("common");

  return (
    <DialogContent
      aria-describedby={undefined}
      className="bg-background absolute! left-0 flex h-dvh max-w-full translate-x-0! flex-col gap-0 rounded-e-none! border-none p-0 md:left-[35%] md:max-h-dvh md:max-w-[65%] xl:left-[60%] xl:max-w-[40vw]"
    >
      <DialogHeader className="px-6 py-5">
        <DialogTitle className="text-xl font-semibold">{t("calendar.slot.details")}</DialogTitle>
      </DialogHeader>
      <Separator className="bg-[#272938]" />

      <AnimatePresence mode="wait">
        <motion.div
          animate="animate"
          className="h-full"
          exit="exit"
          initial="initial"
          variants={fadeAnimation}
        >
          <SlotDetailsContent />
        </motion.div>
      </AnimatePresence>
    </DialogContent>
  );
}
